module.exports = __webpack_public_path__ + "static/img/my_click_nianhuo@2x.0ff04840.png";